var _rect, _path, _path2, _rect2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefrigerantH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#9e9e9e",
    height: 58,
    rx: 2,
    width: 58,
    x: 1,
    y: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 1h-3a2 2 0 0 1 2 2v54a2 2 0 0 1-2 2h3a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15h18a2 2 0 0 1 2 2v42H5V17a2 2 0 0 1 2-2z",
    fill: "#3f51b5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f44335",
    height: 4,
    rx: 2,
    width: 8,
    x: 12,
    y: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 60h54a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v54a3 3 0 0 0 3 3zm-1-3v-1h2v2H3a1 1 0 0 1-1-1zm4 1V17a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v41zm51 0H28v-2h30v1a1 1 0 0 1-1 1zM3 2h54a1 1 0 0 1 1 1v51H28V17a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v37H2V3a1 1 0 0 1 1-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 35h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zM33 31h1.382L33.1 33.553a1 1 0 0 0 1.79.894L36.618 31h3.968l-3.293 3.293a1 1 0 1 0 1.414 1.414L42 32.414v3.968L38.553 38.1a1 1 0 0 0 .894 1.79L42 38.618V40a1 1 0 0 0 2 0v-1.382l2.553 1.282a1 1 0 1 0 .894-1.79L44 36.382v-3.968l3.293 3.293a1 1 0 0 0 1.414-1.414L45.414 31h3.968l1.723 3.447a1 1 0 0 0 1.79-.894L51.618 31H53a1 1 0 0 0 0-2h-1.382l1.282-2.553a1 1 0 0 0-1.79-.894L49.382 29h-3.968l3.293-3.293a1 1 0 0 0-1.414-1.414L44 27.586v-3.968l3.447-1.718a1 1 0 1 0-.894-1.79L44 21.382V20a1 1 0 0 0-2 0v1.382l-2.553-1.277a1 1 0 0 0-.894 1.79L42 23.618v3.968l-3.293-3.293a1 1 0 0 0-1.414 1.414L40.586 29h-3.968L34.9 25.553a1 1 0 0 0-1.79.894L34.382 29H33a1 1 0 0 0 0 2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 51,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 51,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 51,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 51,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 51,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 51,
    r: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11h4a3 3 0 0 0 0-6h-4a3 3 0 0 0 0 6zm0-4h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigerantH);
export default __webpack_public_path__ + "static/media/Refrigerant-h.4716fe84d4269c3f49c0c505f026bf89.svg";
export { ForwardRef as ReactComponent };